/**
 * index.js
 *
 * @Author: jruif
 * @Date: 2017/6/29 下午3:26
 */

import Button from './Button';
import IconButton from './IconButton';

export { IconButton };
export default Button;



// WEBPACK FOOTER //
// ./src/button/index.js